import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Money from '../../../../../../../app/common/money';
import styles from './styles.module.scss';
import { pluralize } from './utils';
import { shouldShowSales } from '../utils';
import { TextM, TextS } from '../../../../../../infra/dls/components/typography';
export var buildSalesProps = function (campaign) { return ({
    shouldShow: shouldShowSales(campaign),
    revenue: campaign.revenue,
    numberOfSales: campaign.numberOfSales,
}); };
export var Sales = function (_a) {
    var shouldShow = _a.shouldShow, revenue = _a.revenue, numberOfSales = _a.numberOfSales;
    if (!shouldShow) {
        return null;
    }
    return (_jsxs("div", { className: styles.multiline, children: [_jsx(TextM, { as: "span", className: styles.header, children: _jsx(Money, { cents: revenue }) }), _jsx(TextS, { as: "span", className: styles.subheader, children: pluralize(numberOfSales, 'sale') })] }));
};
